import type { ISerialize } from '@/objects/ISerialize';

export class StringArray implements ISerialize {
    public Values: string[];

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { Values?: string[] }) {
        this.Values = values.Values ?? [];
    }

    public serialize(): string {
        return '{' + `"Values": [ ${this.Values.map((x) => JSON.stringify(x))} ]` + '}';
    }

    /**
     * Creates an instance of StringArray from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { Values?: string[] }): StringArray {
        return new StringArray(values);
    }

    public static _FromServerJson(json: any): StringArray {
        return new StringArray({ Values: json.Values });
    }

    /**
     * Creates an instance of StringArray from another instance of StringArray.
     * @param other The StringArray you want to clone
     * @returns A cloned StringArray
     */
    public static FromOther(other: StringArray): StringArray {
        return StringArray._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return StringArray.FromOther(this);
    }

    static NAME_OF_CLASS = 'StringArray';
}
